import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../../common/OrangeTextButton";

export const NatWireguardConflictDialog = ({
  open,
  message,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}) => (
  <Dialog
    open={open}
    aria-labelledby="nat-wireguard-conflict-dialog-title"
    aria-describedby="nat-wireguard-conflict-dialog-description"
  >
    <DialogTitle
      id="nat-wireguard-conflict-dialog-title"
      sx={{ fontFamily: "Mulish" }}
    >
      {message}
    </DialogTitle>
    <DialogActions>
      <OrangeTextButton onClick={onCancel} text="No" disabled={false} />
      <OrangeTextButton onClick={onConfirm} text="Yes" disabled={false} />
    </DialogActions>
  </Dialog>
);
